import { Component, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { CurrentService } from 'src/app/services/current.service';
import { Router } from '@angular/router';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { DatasService } from 'src/app/services/datas.service';
import { getAppGtmRef, getAppUrl } from '../../services/helpers/app-context-helper';
import { GTM } from 'src/app/services/gtm.service';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { StatisticService } from 'src/app/services/statistic.service';
import { StatisticTypeEnum } from 'src/app/enum/statistic-type.enum';
import { CastometreService } from 'src/app/services/castometre/castometre.service';

@Component({
  selector: 'ng-casto-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  private readonly castometreDistribId = 'castometre';
  protected readonly faArrowRight = faArrowRight;

  constructor(
    public datas: DatasService,
    public gtm: GTM,
    protected castometre: CastometreService,
    private readonly modalService: ModalService,
    private readonly customer: CustomerService,
    private readonly current: CurrentService,
    private readonly router: Router,
    private readonly statistic: StatisticService
  ) { }

  ngOnInit(): void {
    this.gtm.trackPage(this.router.url, 'Accueil');
  }

  trackCastometreAppStore(): void {
    this.gtm.trackEvent('telecharger-app-castometre-accueil');
    this.sendHomeStatistic(StatisticTypeEnum.CASTOMETRE_DOWNLOAD_CLICKED_COUNT);
  }

  async startNewProject(context: string): Promise<void> {
    this.current.reset();
    this.customer.context = context;
    this.gtm.trackEvent('creer-projet-accueil', { projectType: getAppGtmRef(context) });

    if (context == CONFIG_CONTEXT.KITCHEN) {
      await this.router.navigateByUrl('/cuisine');
    } else if (context == CONFIG_CONTEXT.STORAGE) {
      await this.router.navigateByUrl('/rangements');
    } else if (context == CONFIG_CONTEXT.BATHROOM) {
      await this.router.navigateByUrl('/salle-de-bain');
    } else {
      await this.router.navigateByUrl(getAppUrl(context) + '/configuration');
    }
  }

  goProjects(distribTarget: string) {
    if (this.customer.isLogged) {
      this.gtm.trackEvent('selectionner-projet-accueil', { projectType: getAppGtmRef(distribTarget) });
      this.modalService.display(MODAL.PROJECTS, {
        customerId: this.customer.userDatas.id,
        tabKey: distribTarget,
      });
    } else {
      this.modalService.display(MODAL.LOGIN, {
        loginCallBack: () => {
          this.gtm.trackEvent('selectionner-projet-accueil', { projectType: getAppGtmRef(distribTarget) });
          this.modalService.display(MODAL.PROJECTS, {
            customerId: this.customer.userDatas.id,
            tabKey: distribTarget,
          });
        },
      });
    }
  }

  goCastometreProjects() {
    this.sendHomeStatistic(StatisticTypeEnum.HOME_PROJECTS_OPENED_COUNT);
    this.goProjects(CONFIG_CONTEXT.KITCHEN);
  }

  private sendHomeStatistic(statisticType: StatisticTypeEnum): void {
    this.statistic.sendStatistic(statisticType, 1, this.castometreDistribId);
  }
}
